import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AddProfileDialogComponent } from "../add-profile-dialog/add-profile-dialog.component";
import { DataCatalogueService } from "../../services/data-catalogue.service";
import { ACL } from "../../model/acl";
import { Property } from "../../model/property";
import { CatalogItem } from "../../model/catalog-item";
import { Profile } from "src/app/aixm-profile/model/profile.model";

export interface ProfileData {
  profile: string;
  read: boolean;
  create: boolean;
  update: boolean;
  decommission: boolean;
  mandatory: boolean | "N/A";
  ref?: string; // UUID profila
}

@Component({
  selector: "app-property-access-rights",
  templateUrl: "./property-access-rights.component.html",
  styleUrls: ["./property-access-rights.component.css"],
})
export class PropertyAccessRightsComponent implements OnInit {
  aclData: any;
  profilesMap: Record<string, string> = {};
  displayedColumns: string[] = [
    "profile",
    "read",
    "create",
    "update",
    "decommission",
    "mandatory",
  ];
  dataSource: ProfileData[] = [];

  constructor(
    private dialog: MatDialog,
    private catalogueService: DataCatalogueService,
    public dialogRef: MatDialogRef<PropertyAccessRightsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      propertyName: string;
      propertyGroupName: string;
      propertyId: string;
    }
  ) {}

  ngOnInit(): void {
    this.loadProfiles(() => {
      this.loadACL();
    });

    this.catalogueService
      .getProfiles("2037172d-1390-4033-9017-e5424166927e")
      .subscribe({
        next: (profiles: []) => {
          console.log("Lista profila:", profiles);
        },
        error: (err) => {
          console.error("Greška:", err);
        },
      });
  }

  private loadProfiles(done: () => void): void {
    this.catalogueService
      .getProfiles("2037172d-1390-4033-9017-e5424166927e")
      .subscribe({
        next: (profiles) => {
          this.profilesMap = {};

          profiles.forEach((p: any) => {
            this.profilesMap[p.uuid] = p.name;
          });

          done();
        },
        error: (err) => {
          console.error("Error loading profiles:", err);
          done();
        },
      });
  }

  private loadACL(): void {
    this.catalogueService
      .getPropertyACL(
        "2037172d-1390-4033-9017-e5424166927e",
        this.data.propertyId
      )
      .subscribe({
        next: (res) => {

          this.aclData = res;

          this.dataSource = res.map((item: any) => ({
            profile: this.profilesMap[item.ref] ?? item.ref,
            read: item.read,
            create: item.create,
            update: item.update,
            decommission: item.decommission,
            mandatory: item.mandatory ?? false,
            ref: item.ref,
          }));
          this.dataSource.push({
            profile: "Other profiles",
            read: false,
            create: false,
            update: false,
            decommission: false,
            mandatory: false,
          });
        },
        error: (err) => {
          console.error("Error loading ACL:", err);
        },
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    const aclUpdate: ACL = this.dataSource
      .filter((item) => item.ref)
      .map((item) => ({
        ref: item.ref,
        read: item.read,
        create: item.create,
        update: item.update,
        decommission: item.decommission,
        mandatory: item.mandatory === "N/A" ? false : item.mandatory,
      }));

    const catId = "2037172d-1390-4033-9017-e5424166927e";
    this.catalogueService
      .updatePropertyACL(catId, this.data.propertyId, aclUpdate)
      .subscribe({
        next: (res) => console.log("ACL updated:", res),
        error: (err) => console.error("Error updating ACL:", err),
      });

    this.dialogRef.close(aclUpdate);
  }

  toggleRead(element: ProfileData) {
    element.read = !element.read;

    if (!element.read) {
      element.create = false;
      element.update = false;
      element.decommission = false;

      if (!element.create && !element.update) {
        element.mandatory = "N/A";
      } else {
        element.mandatory = false;
      }
    }
  }

  toggleCreate(element: ProfileData) {
    element.create = !element.create;
    if (element.create) {
      element.read = true;
    }
    if (!element.create && !element.update) {
      element.mandatory = "N/A";
    } else if (element.mandatory === "N/A") {
      element.mandatory = false;
    }
  }

  toggleUpdate(element: ProfileData) {
    element.update = !element.update;
    if (element.update) {
      element.read = true;
    }
    if (!element.create && !element.update) {
      element.mandatory = "N/A";
    } else if (element.mandatory === "N/A") {
      element.mandatory = false;
    }
  }

  // toggleDecommission(element: ProfileData) {
  //   element.decommission = !element.decommission;

  //   if (element.decommission) {
  //     element.read = true;
  //     element.mandatory = false;
  //   }
  // }
  toggleDecommission(element: ProfileData) {
    element.decommission = !element.decommission;

    if (element.decommission) {
      element.read = true;
      element.mandatory = false;
    }

    if (!element.create && !element.update) {
      element.mandatory = "N/A";
    } else if (element.mandatory === "N/A") {
      element.mandatory = false;
    }
  }

  toggleMandatory(element: ProfileData) {
    if (element.mandatory === "N/A") return;

    element.mandatory = !element.mandatory;

    if (element.mandatory) {
      element.create = true;
      element.update = true;
      element.read = true;
      element.decommission = false;
    }
  }

  openAddProfileDialog(): void {
    const dialogRef = this.dialog.open(AddProfileDialogComponent, {
      width: "400px",
      data: {},
    });

    dialogRef.afterClosed().subscribe((selectedProfiles: any[]) => {
      if (selectedProfiles && selectedProfiles.length) {
        selectedProfiles.forEach((profile) => {
          const exists = this.dataSource.some(
            (p) => p.profile === profile.name
          );
          if (!exists) {
            this.dataSource.push({
              profile: profile.name,
              ref: profile.ref,
              read: false,
              create: false,
              update: false,
              decommission: false,
              mandatory: "N/A",
            });
          }
        });

        this.dataSource.sort((a, b) => {
          if (a.profile === "Other profiles") return 1;
          if (b.profile === "Other profiles") return -1;
          return a.profile.localeCompare(b.profile);
        });

        this.dataSource = [...this.dataSource];
      }
    });
  }
}
